import React from "react";

interface IIconProps {
  width?: number;
  height?: number;
}

export default function Compass(props: IIconProps) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 510 510" {...props}>
      <path
        d="M255 226.95c-15.3 0-28.05 12.75-28.05 28.05s12.75 28.05 28.05 28.05 28.05-12.75 28.05-28.05-12.75-28.05-28.05-28.05zM255 0C114.75 0 0 114.75 0 255s114.75 255 255 255 255-114.75 255-255S395.25 0 255 0zm56.1 311.1L102 408l96.9-209.1L408 102l-96.9 209.1z"
        fill="#999"
        fillRule="nonzero"
      />
    </svg>
  );
}
